import ActionButton from "../shared/ActionButton";
import { Alert } from "@mui/material";
import { CallMerge } from "@mui/icons-material";
import { useDuplicateAnalysis } from "../../hooks/useDuplicateAnalysis";

export default function DuplicatesBanner({ onOpen }: { onOpen: () => void }) {
  const { duplicatesCount } = useDuplicateAnalysis();

  if (duplicatesCount === 0) return null;

  return (
    <Alert
      severity="warning"
      sx={{ border: "1px solid #f1c40f", borderRadius: 1 }}
      action={
        <ActionButton
          variant="outlined"
          onClick={onOpen}
          icon={<CallMerge fontSize="small" />}
          sx={{
            py: 0.5,
            px: 1.5,
            fontSize: "0.75rem",
            minWidth: "auto",
            color: "#6366f1",
            borderColor: "#6366f1",
            "&:hover": { backgroundColor: "#f1e7de", borderColor: "#6366f1" },
          }}
        >
          Oczyść teraz
        </ActionButton>
      }
    >
      Wykryto potencjalne duplikaty zawodników: {duplicatesCount}
    </Alert>
  );
}
